import { message } from 'antd';
import React from 'react';
import ServiceManual from './servicePDF';

class ManualComponent extends React.PureComponent {
    componentDidMount = () => {
        if (!localStorage.getItem('id')) {
            message.warning('서비스 매뉴얼을 보시려면 로그인 후 이용해주세요.');
            return this.props.history.push('/user/login');
        }
        this.props.history.push('/service/manual');
    }

    render() {
        return (
            <div className='pdf-form'>
                <ServiceManual />
            </div>
        );
    }
}
export default ManualComponent;